import React, { useState } from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import { Nav, Tab } from "react-bootstrap";
import "./Selection_method.css";
import Repeatability from "./repeatability/Repeatability";
import Reproducibility from "./reproducibility/Reproducibility";
import Accuracy from "./accuracy/Accuracy";

const Selection_method = () => {
  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Selection, Verification & Validation Of Method" />
      </div>

      <div className="tables_tab_section">
        <Tab.Container
          id="left-tabs-example"
          defaultActiveKey="Repeatability"
        >
          <Nav variant="pills" className="">
            <Nav.Item>
              <Nav.Link eventKey="Repeatability">
                Repeatability
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="Reproducibility">Reproducibility</Nav.Link>
            </Nav.Item>


             <Nav.Item>
              <Nav.Link eventKey="Accuracy">Accuracy</Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content className="inner-tab-sec">
            <Tab.Pane eventKey="Repeatability">
              <Repeatability />
            </Tab.Pane>

            <Tab.Pane eventKey="Reproducibility">
              <Reproducibility />
            </Tab.Pane>

            <Tab.Pane eventKey="Accuracy">
              <Accuracy />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </section>
  );
};

export default Selection_method;
